// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b2d7942c6772bf5a5321","655":"1a92a4f936edbb92231e"}[chunkId] + ".js";
};